import { render, staticRenderFns } from "./StatementsItem.vue?vue&type=template&id=061c7528&scoped=true&"
import script from "./StatementsItem.vue?vue&type=script&lang=ts&"
export * from "./StatementsItem.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsItem.vue?vue&type=style&index=0&id=061c7528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c7528",
  null
  
)

export default component.exports